import { action, makeObservable, observable } from 'mobx'
import moment from 'moment'
import FormStore from '../../../utils/stores/FormStore'
import { getComp } from '../../../utils/utils/DI'

export const initParamsState = {
  statuses: [],
  phoneNumber: '',
  id: '',
  fullName: '',
  fullAddress: '',
  createdFrom: null,
  createdTo: null,
  dateOfMaintenanceFrom: null,
  dateOfMaintenanceTo: null,
  dealerIds: [],
  reportId: '',
  year: '',
  address: '',
  month: '',
  equipmentId: '',
  preferentialCategories: [],
  surname: '',
  name: '',
  patronymic: '',
  territory: '',
  district: '',
  locality: '',
  addressType: '',
  house: '',
  building: '',
  apartment: '',
  preferentialCategory: '',
  created: '',
  additionalInfo: '',
  senderId: '',
  maintenanceReasonId: null,
  authorId: '',
  sender: '',
  ticketStatuses: [],
  financialSourceIds: [],
  isUrgent: false,
  dataCheckingStatuses: [],
  receiverSerialNumber: '',
  incidentTypeId: '',
  isRepeatedAppeal: false,
  malfunctionTypeIds: [],
}

const validateData = {
  status: { required: true },
}

class AdminTableFilterStore extends FormStore {
  dealersStore: any
  data: any = initParamsState
  param: any
  constructor() {
    super({
      initState: initParamsState,
      validateData,
    })
    this.dateNames = []
    this.dealersStore = getComp('DealersStore')
    makeObservable(this, {
      isHighlighted: observable,
      data: observable,
      makeHighlightTrue: action,
      makeHighlightFalse: action,
    })
  }

  isHighlighted = false

  makeHighlightTrue = () => {
    if (this.data?.id !== '') {
      return
    }
    this.isHighlighted = true
  }

  makeHighlightFalse = () => (this.isHighlighted = false)

  clear = () => {
    this.setData(initParamsState)
    this.makeHighlightFalse()
    this.param = null
    this.clearSelectedFilters()
  }

  makeParamCopy = (param: any) => {
    this.param = param
  }

  getParamCopy = () => this.param

  getParams = (incedentTypes: any) => {
    const param = {} as Record<string, any>

    for (const key in this.data) {
      if (!!this.data[key]) {
        switch (key) {
          case 'dateOfMaintenanceFrom':
          case 'dateOfMaintenanceTo':
          case 'createdFrom':
          case 'createdTo':
            if (key.includes('From')) {
              param[key] = this.data[key].format()
            } else {
              param[key] = this.data[key].endOf('day').format()
            }
            break
          case 'dealerIds':
            param[key] = this.data[key].map(
              (aid: any) =>
                getComp('DealersStore').getDealerBuyAid(aid)?.subjectId,
            )
            break
          case 'incidentTypeId':
            param['incidentTypeId'] = incedentTypes.find(
              (type: any) => type.name === this.data[key],
            )?.id
            break
          case 'sender':
            param['senderId'] = this.data[key]
            break
          case 'year':
            param['year'] = this.data[key]
            break
          case 'month':
            param['month'] = this.data[key]
            param['year']
              ? (param['year'] = param['year'])
              : (param['year'] = +moment().year())
            break
          case 'phoneNumber':
            param['phoneNumber'] = normalizePhoneNumber(this.data[key])
            break
          default:
            param[key] = this.data[key]
            break
        }
      }
    }
    return param
  }
}

function normalizePhoneNumber(phoneNumber: string | number) {
  return String(phoneNumber).replace(/\D/g, '')
}

export type AdminTableFilterStoreType = InstanceType<
  typeof AdminTableFilterStore
>

export default AdminTableFilterStore
